import React from 'react';
import iconAI from '../assets/images/logo/IconAI.png';

const GuideTopAI: React.FC = () => {
  return (
    <div
      className="w-full p-4 rounded-xl border border-[#FFD6A7] flex items-start gap-2.5"
      style={{
        background: '#FBE5D6',
      }}
    >
      {/* IconAI */}
      <img
        src={iconAI}
        alt="AI"
        className="w-5 flex-shrink-0 mt-0.5"
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />

      {/* GuideTopAIText */}
      <div className="flex flex-col gap-1">
        {/* Heading */}
        <div
          className="text-base font-medium"
          style={{
            fontFamily: 'Noto Sans JP',
            color: '#0D357F',
          }}
        >
          この内容はAIが会社情報をもとに生成した下書きです。自社の実態に沿うように、内容を精査のうえ編集してください。
        </div>

        {/* Text */}
        <div
          className="text-sm"
          style={{
            fontFamily: 'Noto Sans JP',
            fontWeight: 350,
            color: '#333333',
          }}
        >
          各セクションの「AIに相談」ボタンから、詳しいアドバイスを受けることができます。
          <br />
          追加入力が必要な項目については、適宜ご自身で加筆してください。
        </div>
      </div>
    </div>
  );
};

export default GuideTopAI;
